export default "__VITE_ASSET__CRzKymXr__"